import { render, staticRenderFns } from "./leaveApply.vue?vue&type=template&id=2d992b6f"
import script from "./leaveApply.vue?vue&type=script&lang=js"
export * from "./leaveApply.vue?vue&type=script&lang=js"
import style0 from "./leaveApply.vue?vue&type=style&index=0&id=2d992b6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports